import config from "../config/config";
import { apiConfig } from "../config/apiConfig";
import ApiService from "./apiService";
import { sharedData } from "../sharedData/sharedData";

class ManagementStructureService {
    static instance;
    
    constructor () {
        if (!ManagementStructureService.instance) {
            this.instance = this;
            this.baseUrl = config['backend-url'].endsWith('/') ? config['backend-url'].slice(0, -1) : config['backend-url'];
            this.useToken = true;
            this.dontUseToken = false;
            this.apiService = new ApiService(this.baseUrl);
        }
        return ManagementStructureService.instance;
    }

    // A counterparty can be shared by two requests, so entityId alone does not identify
    // the row. Sent from here rather than from each caller so none of them can forget it.
    // save-management-data already stores it; the reads fall back to an entity-only
    // lookup until the backend query refactor lands, and log when they do.
    async saveManagementStructure( payload ) {
        const response = await this.apiService.post(
            apiConfig.managementStructure.saveManagementStructure,
            { requestId: sharedData.get("requestId"), ...payload },
            this.useToken
        );
        // See the note in corporateStructureService: saving into a Simplified section makes
        // it required, so drop the cached "Not Applicable" right away.
        // See the note in corporateStructureService: never guess a status the caller
        // did not state.
        if (response.ok) {
            const { management, ...cached } = sharedData.get("sectionStatuses") || {};
            sharedData.set("sectionStatuses",
                payload.status ? { ...cached, management: payload.status } : cached);
        }
        return response;
    }

    async getManagementStrcutureByEntityId( entityId, requestId = null ) {
        const response = await this.apiService.post(
            apiConfig.managementStructure.getManagementStructure,
            { entityId, requestId: requestId || sharedData.get("requestId") },
            this.useToken
        );
        return response;
    }
    async getQuickManagementStrcutureByEntityId( entityId, requestId = null ) {
        const response = await this.apiService.post(
            apiConfig.managementStructure.getQuickManagementStructure,
            { entityId, requestId: requestId || sharedData.get("requestId") },
            this.useToken
        );
        return response;
    }

}

export const managementStructureService = new ManagementStructureService();